<template>
  <div class="swiper_honor">
    <div class="home_con">
      <ul class="pages">
          <li v-for="(item,index) in initSize()?6:10" :key="index"> <p v-show="activeIndex == index" ref="page_size"></p> </li>
      </ul>
      <div class="swiper_hopc">
        <div class="swiper-container1 swiper-no-swiping">
          <div class="home_tit">资质与荣誉</div>
          <div class="swiper-wrapper">
            <div class="swiper-slide">
              <ul>
                <li><img src="@/assets/pcho/11/1.png" alt="" /></li>
                <li><img src="@/assets/pcho/11/2.png" alt="" /></li>
                <li><img src="@/assets/pcho/11/3.png" alt="" /></li>
                <li><img src="@/assets/pcho/11/4.png" alt="" /></li>
                <li><img src="@/assets/pcho/11/5.png" alt="" /></li>
              </ul>
            </div>
            <div class="swiper-slide">
              <ul>
                <li><img src="@/assets/pcho/11/6.png" alt="" /></li>
                <li><img src="@/assets/pcho/11/7.png" alt="" /></li>
                <li><img src="@/assets/pcho/11/8.png" alt="" /></li>
                <li><img src="@/assets/pcho/11/9.png" alt="" /></li>
                <li><img src="@/assets/pcho/11/10.png" alt="" /></li>
              </ul>
            </div>
            <div class="swiper-slide">
              <ul>
                <li><img src="@/assets/pcho/11/11.png" alt="" /></li>
                <li><img src="@/assets/pcho/11/12.png" alt="" /></li>
                <li><img src="@/assets/pcho/11/13.png" alt="" /></li>
                <li><img src="@/assets/pcho/11/14.png" alt="" /></li>
                <li><img src="@/assets/pcho/11/15.png" alt="" /></li>
              </ul>
            </div>
            <div class="swiper-slide">
              <ul>
                <li><img src="@/assets/pcho/11/16.png" alt="" /></li>
                <li><img src="@/assets/pcho/11/17.png" alt="" /></li>
                <li><img src="@/assets/pcho/11/18.png" alt="" /></li>
                <li><img src="@/assets/pcho/11/19.png" alt="" /></li>
                <li><img src="@/assets/pcho/11/20.png" alt="" /></li>
              </ul>
            </div>
            <div class="swiper-slide">
              <ul>
                <li><img src="@/assets/pcho/11/21.png" alt="" /></li>
                <li><img src="@/assets/pcho/11/22.png" alt="" /></li>
                <li><img src="@/assets/pcho/22/1.png" alt="" /></li>
                <li><img src="@/assets/pcho/22/2.png" alt="" /></li>
                <li><img src="@/assets/pcho/22/3.png" alt="" /></li>
                
              </ul>
            </div>
            
            <div class="swiper-slide">
              <ul>
                <li><img src="@/assets/pcho/22/4.png" alt="" /></li>
                <li style="width:362px;height:254px;"><img style="width:100%;height:100%;" src="@/assets/pcho/33/1.png" alt="" /></li>
                <li style="width:362px;height:254px;margin-left: 16px;"><img style="width:100%;height:100%;" src="@/assets/pcho/33/2.png" alt="" /></li>
              </ul>
            </div>
          </div>
        </div>
         <!-- 如果需要分页器 -->
          <div class="swiper-pagination"></div>
      </div>

      <div class="swiper_homo">
        <div class="swiper-container1">
          <div class="home_tit" style="padding: 25px 0px;">资质与荣誉</div>
          <div class="swiper-wrapper">
            <div class="swiper-slide">
              <ul>
                <li><img src="@/assets/moho/1.png" alt="" /></li>
                <li><img src="@/assets/moho/2.png" alt="" /></li>
                <li><img src="@/assets/moho/3.png" alt="" /></li>
              </ul>
            </div>
            <div class="swiper-slide">
              <ul>
                <li><img src="@/assets/moho/4.png" alt="" /></li>
                <li><img src="@/assets/moho/5.png" alt="" /></li>
                <li><img src="@/assets/moho/6.png" alt="" /></li>
              </ul>
            </div>
            <div class="swiper-slide">
              <ul>
                <li><img src="@/assets/moho/7.png" alt="" /></li>
                <li><img src="@/assets/moho/8.png" alt="" /></li>
                <li><img src="@/assets/moho/9.png" alt="" /></li>
              </ul>
            </div>
            <div class="swiper-slide">
              <ul>
                <li><img src="@/assets/moho/10.png" alt="" /></li>
                <li><img src="@/assets/moho/11.png" alt="" /></li>
                <li><img src="@/assets/moho/12.png" alt="" /></li>
              </ul>
            </div>
            <div class="swiper-slide">
              <ul>
                <li><img src="@/assets/moho/13.png" alt="" /></li>
                <li><img src="@/assets/moho/14.png" alt="" /></li>
                <li><img src="@/assets/moho/15.png" alt="" /></li>
              </ul>
            </div>
            <div class="swiper-slide">
              <ul>
                <li><img src="@/assets/moho/16.png" alt="" /></li>
                <li><img src="@/assets/moho/17.png" alt="" /></li>
                <li><img src="@/assets/moho/18.png" alt="" /></li>
              </ul>
            </div>
            <div class="swiper-slide">
              <ul>
                <li><img src="@/assets/moho/19.png" alt="" /></li>
                <li><img src="@/assets/moho/20.png" alt="" /></li>
                <li><img src="@/assets/moho/21.png" alt="" /></li>
              </ul>
            </div>
            <div class="swiper-slide">
              <ul>
                <li><img src="@/assets/moho/22.png" alt="" /></li>
                <li><img src="@/assets/moho/23.png" alt="" /></li>
                <li><img src="@/assets/moho/24.png" alt="" /></li>
              </ul>
            </div>
            <div class="swiper-slide">
              <ul>
                <li><img src="@/assets/moho/25.png" alt="" /></li>
                <li><img src="@/assets/moho/26.png" alt="" /></li>
                <li><img src="@/assets/moho/26.png" alt="" /></li>
              </ul>
            </div> 
            <div class="swiper-slide">
              <ul class="display:flex;justify-content: center;">
                 <li style="width:210px;height:147px;"><img style="width:100%;height:100%" src="@/assets/moho/27.png" alt="" /></li>
               
              </ul>
            </div>
            <div class="swiper-slide">
              <ul class="display:flex;justify-content: center;">
               
                <li style="width:210px;height:147px;"><img style="width:100%;height:100%" src="@/assets/moho/28.png" alt="" /></li>
              </ul>
            </div>
          </div>
          <!-- <br /><br /> -->
          <!-- 如果需要分页器 -->
          <div style="margin-top:132px!important;">
            <div class="swiper-pagination"></div>
          </div>
          
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return{
      activeIndex:0
    }
  },
  mounted() {
    let _this = this
    let mySwiper = new Swiper(".swiper-container1", {
      direction: "horizontal", // 垂直切换选项
       autoplay: {
        delay: 5000,
        pauseOnMouseEnter: true,
        // disableOnInteraction: false,
      },
     
      pagination: {
        el: "",
      },
      on:{
        slideChangeTransitionEnd: function(){
          var is = false
          if(!is){
            _this.activeIndex = this.activeIndex
            is = true
            setTimeout(()=>{
              is = false
            },5000)
          }
        },
      },
    });
    this.$nextTick(()=>{
      mySwiper[0].el.onmouseover = function(){
        mySwiper[0].autoplay.stop();
      }
      mySwiper[0].el.onmouseout = function(){
        mySwiper[0].autoplay.start();
      }
    })
  },
  methods:{
    initSize() {
      return document.body.clientWidth > 768;
    },
  },
  onInit: function (swiper) {
    swiperAnimateCache(swiper); //隐藏动画元素
    swiperAnimate(swiper); //初始化完成开始动画
  },
  onSlideChangeEnd: function (swiper) {
    swiperAnimate(swiper); //每个slide切换结束时也运行当前slide动画
  },
};
</script>



<style scoped>
.swiper-container1 {
  width: 100%;
  overflow: hidden;
  
}
.swiper-slide ul {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
}
.swiper_honor {
  width: 100%;
  height: 504px;
  background: #f5f7fa;
  background-image: url('https://www.bjecpower.com/camera/company/ry.png');
  background-size: 100%;
  background-repeat: no-repeat;
}
.swiper_homo {
  display: none;
  background: #fff;
}
.swiper_hopc .swiper-slide ul li {
  width: 18%;
  margin-left: 16px;
}
.swiper_hopc .swiper-slide ul li:nth-child(1) {
  margin-left: 0px;
}
.swiper_hopc .swiper-slide ul li img {
  width: 177px;
  height: 254px;
}
.swiper_hopc
  .swiper-container1-horizontal
  > .swiper-pagination-bullets
  .swiper-pagination-bullet {
  width: 30px;
  height: 3px;
  background: #0084ff;

}
.swiper_hohpc .swiper-pagination-bullet-active {
  background: #e7ecf3;
  width: 30px !important;
}

.pages{
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  /* bottom: 25px; */
  bottom: 290px;
  height: 3px;
  display: flex;
  box-sizing: border-box;
  padding: 0 0 0 8px;
}
.pages li{
  position: relative;
  width: 30px;
  margin-right: 8px;
  height: 3px;
  background: #e7ecf3;
}
.pages li p{
  position:absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #0084ff;
  /* z-index: -1; */
  animation: slidetounlock 5s linear;
}
@keyframes slidetounlock {
  0% {
    width: 0px;
  }
  100% {
    width: 100%;
  }
}
@media screen and (max-width: 1440px) {

}
@media screen and (max-width: 768px) {
  
.pages{
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
 
  bottom: 14.5%;
  height: 3px;
  display: flex;
  box-sizing: border-box;
  padding: 0 0 0 8px;
}
  .pages li{
    width: 15px;
  }
   .swiper_honor {
    width: 100%;
    height:268px;
    background-image: url(https://www.bjecpower.com/camera/company/zzbj.png);
    background-size: 100% 100%;
  }
  .swiper_hopc {
    display: none;
  }
  .swiper_homo {
    display: block;
     width: 100%;
    height:268px;
    background-image: url(https://www.bjecpower.com/camera/company/zzbj.png);
    background-size: 100% 100%;
  }
  .swiper_homo .swiper-slide ul li {
    width: 33%;
  }
  .swiper_homo .swiper-slide ul li img {
    width: 109px;
    height: 147px;
  }
  .swiper_homo
    .swiper-container1-horizontal
    > .swiper-pagination-bullets
    .swiper-pagination-bullet {
    width: 15px;
    height: 3px;
    background: #0084ff;
    border-radius: 0;
    margin-top: 10px;
  }
  .swiper_homo .swiper-pagination-bullet-active {
    background: #e7ecf3;
    width: 15px !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/honor.vue